export var Effect;
(function (Effect) {
    Effect[Effect["Allow"] = 1] = "Allow";
    Effect[Effect["Deny"] = 2] = "Deny";
    Effect[Effect["Indeterminate"] = 3] = "Indeterminate";
})(Effect || (Effect = {}));
var AbstractEffector = /** @class */ (function () {
    function AbstractEffector(expr, pm) {
        this.pm = pm;
        this._effector = '';
        this.setEffector(expr);
    }
    return AbstractEffector;
}());
export { AbstractEffector };
